<template>
  <div>
    <div
      v-for="offer in textids"
      :key="offer.id"
      :class="[`alert alert-${offer.class}`, (parentPage === 'booking')? 'mt-3':'']"
      tabindex="0"
    >
      <b>{{ $t(offer.head) }}</b>
      {{ $t(offer.text+'.'+offer.id) }}
    </div>
  </div>
</template>
<script>
import config from 'config/appConfig';
import 'scss/bootstrap/vue/components/tooltip.scss';
import offerDateCheck from 'mixins/offerDateCheck';
import { mapMutations } from 'vuex';

export default {
  name: 'InfoBanner',
  i18nOptions: { namespaces: 'offers' },
  mixins: [offerDateCheck],
  props: {
    objectData: {
      required: true,
      type: Object,
    },
    parentPage: {
      type: String,
      default: 'object',
    },
    startDate: {
      type: [String, Date],
      default: null,
    },

  },
  data() {
    return {
      idPool: config.offerList.infolabel,
    };
  },
  computed: {
    objectNumber() {
      return this.objectData.objectNumber;
    },
    offerIds() {
      return this.objectData.searchOffers;
    },
    textids() {
      // filters the object by id and looks only for ids that are also in this.ids then checks which of the
      // objects in distinctions has the ignore key, and throws the ignored one out. splice used because only three badges should be displayed
      if (!this.idPool) { return false; }
      const { startDate } = this; // get from booking property or object page store value
      return this.idPool
        .filter((el) => this.offerDateCheck(el, startDate)) // offers with dates
        .filter((el) => this.offerIds.includes(el.id)) // has object offer id
        .filter((el) => !this.idPool.map((el2) => el2.ignore).includes(el.id)) // should not be ignored
        .splice(0, 3); // give 3
    },
  },
  methods: {
    ...mapMutations({ cancelAble: 'SET_CANCELABEL' }),
  },
};
</script>
